import Vue from "vue";
import VueGridLayout from "vue-grid-layout";
import { GridLayout, GridItem } from "vue-grid-layout";

Vue.use(VueGridLayout);
Vue.component("grid-layout", GridLayout);
Vue.component("grid-item", GridItem);

export default VueGridLayout;
